import { Col, Form, Input } from 'antd';
import React, { FC } from 'react'
import { PrefixGameMetaTypes } from '~types/prefixs'

interface GameMetaGroupProps {
    gameMeta?: Record<PrefixGameMetaTypes, string>
}
export const Msnslot: FC<GameMetaGroupProps> = ({ gameMeta }) => {
    return (
        <>
            <Col xs={24} sm={24}>
                <Form.Item
                    name={["gameMeta", "key"]}
                    label="MSNSLOT Key"
                    rules={[{ required: true, message: 'กรุณากรอก MSNSLOT Key!' }]}
                    hasFeedback>
                    <Input placeholder="MSNSLOT Key" inputMode="text" />
                </Form.Item>
            </Col>
        </>
    )
}
